// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registerStep2Container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 0 20px;
}

.registerStep2Container form {
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.registerStep2Container p{
    max-width: 500px;
}

.registerStep2Container .inputGroup {
    display: flex;
    gap: 15px;
    margin-bottom: 0;
}

.registerStep2Container .inputWithIcon {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
}

.registerStep2Container .inputWithIcon input {
    width: 100%;
    padding: 12px 10px;
    border-radius: 10px;
    border: none;
    background-color: #f0f0f0;
    font-size: 16px;
}

.registerStep2Container .termsContainer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 14px;
}

.registerStep2Container .termsContainer input {
    margin: 0;
}

.registerStep2Container .termsContainer p {
    color: #C3D32C;
}

.registerStep2Container .termsContainer a {
    color: #C3D32C;
    text-decoration: underline;
}

.registerStep2Container button {
    margin-top: 16px;
    padding: 16px;
    border: none;
    border-radius: 30px;
    background-color: #C3D32C;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
}

.registerStep2Container form input.invalid {
    border: red 2px solid;
}

.registerStep2Container form .termsContainer.invalid p {
    color: red;
}

.registerStep2Container .buttonsContainer {
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;
}

.registerStep2Container p{
    font-family: Lato;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 16px;
    text-align: left;
    width: 100%;
}

.paymentContainer{
    width: 100%;
}

.paymentContainer p{
    font-family: Lato;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 16px;
}

.paymentContainer button{
    width: 100%;
    background-color: transparent;
    border: 2px solid #C3D32C;
    color: #C3D32C;
}

.payment-error-message{
    text-align: center;
    margin-bottom: 16px;
    color: #ca5858;
}`, "",{"version":3,"sources":["webpack://./src/components/Register/RegisterStep2.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".registerStep2Container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 100%;\r\n    padding: 0 20px;\r\n}\r\n\r\n.registerStep2Container form {\r\n    width: 100%;\r\n    max-width: 500px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.registerStep2Container p{\r\n    max-width: 500px;\r\n}\r\n\r\n.registerStep2Container .inputGroup {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.registerStep2Container .inputWithIcon {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n.registerStep2Container .inputWithIcon input {\r\n    width: 100%;\r\n    padding: 12px 10px;\r\n    border-radius: 10px;\r\n    border: none;\r\n    background-color: #f0f0f0;\r\n    font-size: 16px;\r\n}\r\n\r\n.registerStep2Container .termsContainer {\r\n    margin-top: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n    font-size: 14px;\r\n}\r\n\r\n.registerStep2Container .termsContainer input {\r\n    margin: 0;\r\n}\r\n\r\n.registerStep2Container .termsContainer p {\r\n    color: #C3D32C;\r\n}\r\n\r\n.registerStep2Container .termsContainer a {\r\n    color: #C3D32C;\r\n    text-decoration: underline;\r\n}\r\n\r\n.registerStep2Container button {\r\n    margin-top: 16px;\r\n    padding: 16px;\r\n    border: none;\r\n    border-radius: 30px;\r\n    background-color: #C3D32C;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n}\r\n\r\n.registerStep2Container form input.invalid {\r\n    border: red 2px solid;\r\n}\r\n\r\n.registerStep2Container form .termsContainer.invalid p {\r\n    color: red;\r\n}\r\n\r\n.registerStep2Container .buttonsContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    flex-direction: column-reverse;\r\n}\r\n\r\n.registerStep2Container p{\r\n    font-family: Lato;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    margin-bottom: 16px;\r\n    text-align: left;\r\n    width: 100%;\r\n}\r\n\r\n.paymentContainer{\r\n    width: 100%;\r\n}\r\n\r\n.paymentContainer p{\r\n    font-family: Lato;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.paymentContainer button{\r\n    width: 100%;\r\n    background-color: transparent;\r\n    border: 2px solid #C3D32C;\r\n    color: #C3D32C;\r\n}\r\n\r\n.payment-error-message{\r\n    text-align: center;\r\n    margin-bottom: 16px;\r\n    color: #ca5858;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
